<template>
  <div class="opt-content-column-wrapper">
    <!-- eslint-disable vue/no-v-html -->
    <el-popover
      placement="bottom-start"
      width="200"
      trigger="hover"
      :content="completeContent"
    >
      <p slot="reference" v-html="transOptContent" />
    </el-popover>

  </div>
</template>

<script>
import { highlightTitle } from "@/views/zhiji/js/common/constants";

export default {
  name: "OptContentColumn",
  props: ["row"],
  data() {
    return {
      completeContent: "",
    };
  },
  computed: {
    transOptContent() {
      const reg = new RegExp(/&nbsp;/, "g");
      let  optContent  = this.row.optContent;
      this.completeContent = optContent;
      highlightTitle.forEach((item) => {
        optContent = optContent.replace(item, `<span style='color:#2088F3'>${item}</span>`);
      });

      return optContent.replace(reg, "<i style='margin: auto 12px;'></i>");
    },
  },
};
</script>

<style lang="less" scoped>
.opt-content-column-wrapper {
    max-width: 855px;
    overflow: hidden;
    margin-right: 10px;
    box-sizing: border-box;
    &:hover > p {
        cursor: pointer;
        text-decoration: underline #2088f3;
    }
    p {
        max-width: 845px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
</style>
